/**
 * Local-dev feature-flag override parsed from a public env var so both server
 * RSC gates and client hooks make the same decision without contacting PostHog.
 */
const FORCED_FEATURE_FLAGS = new Set(
  (process.env.NEXT_PUBLIC_FEATURE_FLAGS_ENABLED ?? '')
    .split(',')
    .map(flag => flag.trim())
    .filter(Boolean)
);

/** Returns true when the flag is force-enabled via NEXT_PUBLIC_FEATURE_FLAGS_ENABLED. */
export function isFeatureFlagForced(flagName: string): boolean {
  return FORCED_FEATURE_FLAGS.has(flagName);
}
